import React from 'react';
import css from './ConfigureWidgets.module.scss';
import {Section} from '../section/Section';
import {ButtonV2} from '../../../system/ButtonV2/ButtonV2';
import {SETUP_STEP_TYPES} from '../../../setupSteps/SetupStepTypes';

export const ConfigureWidgetsSection: React.FC<{
  type: SETUP_STEP_TYPES;
}> = ({type}) => {
  return (
    <Section type={type}>
      <div className={css.section}>
        <div className={css.header_container}>
          <div className={css.title}>Explore, Customize, Combine</div>
          <div className={css.text}>
            Choose from a variety of unique widgets to showcase your creativity,
            highlight emotions, or display heart rate dynamics. Personalize them
            with your own images, fonts, and more. Easily use multiple widgets
            in OBS as separate browser sources or switch them based on your
            stream's activity.
          </div>
        </div>
        <img
          className={css.gif}
          src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content/setup-wizard/explore_widgets_opt.gif"
        ></img>
        <ButtonV2
          size="small"
          className={css.button}
          href="https://pulsoid.net/ui/configuration"
          target="_blank"
        >
          Configure Widgets
        </ButtonV2>
      </div>
    </Section>
  );
};
